import 'url-search-params-polyfill';
import fetch from '../../utils/fetch';
import { getClientToken } from '../../utils/helpers';
import { publicHash } from '../../utils/constants';

const linkedinLoginAPI = ({ code, redirectUri }) => {
  const accessToken = getClientToken().access_token;

  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    Authorization: `Bearer ${accessToken}`,
  };

  const data = new URLSearchParams();
  data.append('grant_type', 'authorization_code');
  data.append('code', code);
  data.append('redirect_uri', redirectUri);
  data.append('client_id', '77l0f5hk7sxd6z');
  data.append('client_secret', 'wqYaA4B0Qffo4Jco');
  return fetch({
    method: 'POST', customUrl: `${publicHash}/linkedin`, route: '/oauth/v2/accessToken', requestHeaders: headers, data, basic: false,
  });
};

export default linkedinLoginAPI;




// WEBPACK FOOTER //
// ./src/reducers/linkedin/api.js